import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import { useTranslation } from "@i18n";
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
import stl from "./DmanProgram.module.css";
import { trackEvents } from "@/common/events/events";
import useHelpers from "@hooks/useHelpers";
import { usePostDetails } from "@/common/Contexts/PostDetailsContext";
var SingleDmanBox = function SingleDmanBox(props) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var _usePostDetails = usePostDetails(),
    helpers = _usePostDetails.helpers;
  var _useState = useState(false),
    ShowPopUp = _useState[0],
    setShowPopUp = _useState[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.DmanBoxContainer,
    id: "daman-option-".concat(props.index),
    onClick: function onClick() {
      setShowPopUp(true);
      trackEvents("usp_view", _objectSpread(_objectSpread({}, helpers.getG4_data()), {}, {
        usp_type: props.text.replace(/100/g, "200")
      }));
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: props.icn,
    alt: "icon",
    loading: "eager",
    width: "52px",
    height: "51px",
    id: "daman-option-icon-".concat(props.index)
  }), /*#__PURE__*/React.createElement("strong", {
    id: "daman-option-title-".concat(props.index)
  }, props.text.replace(/100/g, "200")), /*#__PURE__*/React.createElement("span", {
    id: "daman-option-more-".concat(props.index)
  }, t("more", {
    ns: "web_common"
  }))), /*#__PURE__*/React.createElement(BottomSheetPopup, {
    show: ShowPopUp,
    onClose: function onClose() {
      setShowPopUp(false);
    },
    className: stl.customPostViewPopup
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.PopUpText,
    id: "daman-popup-".concat(props.index)
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.popUpContentsSDB
  }, /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement("img", {
    src: props.icn,
    alt: "icon"
  }), /*#__PURE__*/React.createElement("span", null, props.text.replace(/100/g, "200"))), /*#__PURE__*/React.createElement("p", {
    id: "daman-popup-content-".concat(props.index)
  }, props.content.replace(/100/g, "200")))), /*#__PURE__*/React.createElement("div", {
    className: stl.termsAndConditions
  }, /*#__PURE__*/React.createElement("a", {
    href: createUrl("/car-purchase-terms-conditions"),
    id: "daman-terms-link-".concat(props.index)
  }, t("apply_terms_conditions", {
    ns: "web_post_view"
  })))));
};
export default SingleDmanBox;